<script>
    import NauiTable from "../../naui/components/NauiTable.svelte";
    import {onMount, createEventDispatcher} from "svelte";

    export let data;
    let _data = [];

    export let documentoLabel = 'Documento';
    export let archivoLabel = 'Archivo';
    // export let categoryLabel = 'Categoría';
    export let actionsLabel = '';
    export let category = false;
    export let checkbox = true;
    export let optionGroup = null;
    export let readOnly = false;
    export let customUploadEvent = false;

    let fileList = {};
    let dispatch = createEventDispatcher();

    onMount(() => {
        generateTableSchema();
        runAdaptor();
    });

    let columns = [
        {
            slug: 'slug',
            label: '',
            type: 'checkbox',
            width: 'max-content',
            order: false
        },
        {
            slug: 'label',
            label: documentoLabel,
            class: '',
            width: '400px',
            type: 'text',
            order: false
        },
        {
            slug: 'archivo',
            label: archivoLabel,
            class: '',
            type: 'text',
            order: false
        },
        {
            slug: 'completed',
            label: 'Estado',
            class: '',
            type: 'icon',
            order: false
        },
        {
            slug: 'actions',
            label: actionsLabel,
            width: '160px',
            type: 'actions',
        }
    ];

    function generateTableSchema() {
        if (!category) {
            columns = [...columns.slice(0, 3), ...columns.slice(4)]
        }
        if (!checkbox) {
            columns = [...columns.slice(1)]
        }
    }

    function runAdaptor() {
        _data = data.map((x) => {
            return {
                slug: x.slug,
                label: x.label,
                archivo: getFileName(x.route),
                category: x.category,
                ref: null,
                completed: x.completed ? {
                    icon: 'done',
                    iconStyle: 'outlined',
                    color: 'secondary',
                } : {icon: 'horizontal_rule', iconStyle: 'outlined', color: 'text-light'},
                actions: getActions(x.route)
            };
        });
    }

    function getFileName(route) {
        if (route) {
            const folders = route.split('/');
            return folders[folders.length - 1];
        } else {
            return '';
        }
    }

    function getActions(route) {
        let response;
        if (route) {
            response = [
                {
                    icon: 'refresh',
                    iconFamily: 'outlined',
                    color: 'secondary',
                    slug: 'load'
                },
                {
                    icon: 'file_download',
                    iconFamily: 'outlined',
                    slug: 'download',
                    route: route,
                    download: true
                },
                {
                    icon: 'delete',
                    iconFamily: 'outlined',
                    slug: 'remove',
                }
            ]
        } else {
            response = [
                {
                    icon: 'file_upload',
                    iconStyle: 'outlined',
                    color: 'secondary',
                    slug: 'load',
                },
                {
                    icon: 'file_download',
                    iconStyle: 'outlined',
                    disabled: true,
                    slug: 'download',
                    download: true
                },
                {
                    icon: 'delete',
                    iconStyle: 'outlined',
                    disabled: true,
                    slug: 'remove',
                }
            ]
        }

        if (readOnly) {
            response = response.filter(i => i.download);
        }
        return response;
    }

    function handleAction(ev) {
        if (ev.detail.action === 'load') {
            if (customUploadEvent) {
                dispatch('customUpload', ev.detail.slug);
            }
            else {
                const item = _data.find(d => d.slug === ev.detail.slug);
                const input = item.ref;
                input.click();
            }
        } else if (ev.detail.action === 'remove') {
            if (confirm('¿Desea eliminar este archivo?')) {
                dispatch('remove', {slug: ev.detail.slug});
            }
        }
    }

    function updateFileList(ev, slug) {
        const entry = _data.find(d => d.slug === slug);
        const files = ev.target.files;

        if (entry && files.length > 0) {
            entry.archivo = ev.target.files[0].name;
            fileList[slug] = ev.target.files[0];
            _data = _data;
        } else {
            delete fileList[slug];
        }
        dispatch('files', fileList);
    }

    function updateData(ev) {
        const d = data.find(x => x.slug === ev.detail.slug);
        const _d = _data.find(x => x.slug === ev.detail.slug);

        if (d) {
            d.category = ev.detail.data;
        }
        if (_d) {
            _d.category = ev.detail.data;
        }
    }
</script>
{#if _data}
    <NauiTable {columns} data={_data} {optionGroup} on:action={handleAction} on:checked on:change={updateData}/>
    <div class="file-input-list">
        {#each _data as document (document.slug)}
            <input type="file" bind:this={document.ref} on:change={(ev => {updateFileList(ev, document.slug)})}>
        {/each}
    </div>
{/if}
<style>
    .file-input-list {
        display: none;
    }
</style>
